//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Chart from '../../general/Chart';
import MixinBmi from './MixinBmi';
export default {
  name: 'WeightChart',
  components: {
    Chart: Chart
  },
  props: {
    data: {
      type: Array,
      default: null
    },
    person: {
      type: Object,
      default: null
    }
  },
  computed: {
    setDefinitions: function setDefinitions() {
      return [{
        title: t('health', 'Weight', {}),
        columnId: 'weight',
        timeId: 'date',
        valueId: 'weight',
        getValueY: function getValueY(v) {
          return v;
        },
        borderColor: 'darkblue',
        borderWidth: 2,
        fill: true,
        show: this.person.weightColumnWeight,
        axesId: 'primary'
      }, {
        title: t('health', 'BMI', {}),
        columnId: 'bmi',
        timeId: 'date',
        valueId: 'calculate',
        getValueY: function getValueY(d) {
          return Math.round(this.calcData.bmiApi.methods.bmi(this.calcData.person, d.weight));
        },
        calcData: {
          person: this.person,
          bmiApi: MixinBmi
        },
        borderColor: 'rgb(15,128,114)',
        borderWidth: 1,
        fill: false,
        show: this.person.weightColumnBmi,
        axesId: 'bmi'
      }, {
        title: t('health', 'Target', {}),
        columnId: 'target',
        timeId: 'date',
        valueId: 'static',
        getValueY: this.person.weightTarget,
        borderColor: 'darkgreen',
        borderWidth: 2,
        borderDash: [8, 5],
        fill: false,
        show: !!this.person.weightTarget && this.person.weightColumnWeight,
        axesId: 'primary'
      }, {
        title: t('health', 'Initial weight', {}),
        columnId: 'initialWeight',
        timeId: 'date',
        valueId: 'static',
        getValueY: this.person.weightTargetInitialWeight,
        borderColor: 'darkred',
        borderWidth: 2,
        borderDash: [2, 5],
        fill: false,
        show: !!this.person.weightTargetInitialWeight && this.person.weightColumnWeight,
        axesId: 'primary'
      }, {
        title: t('health', 'Bodyfat', {}),
        columnId: 'bodyfat',
        timeId: 'date',
        valueId: 'bodyfat',
        getValueY: function getValueY(v) {
          return v;
        },
        borderColor: 'rgb(99,22,122)',
        borderWidth: 2,
        fill: false,
        show: this.person.weightColumnBodyfat,
        axesId: 'bodyfat'
      }, {
        title: 'weightMeasurementName' in this.person && this.person.weightMeasurementName ? this.person.weightMeasurementName : t('health', 'Measurementdata'),
        columnId: 'measurement',
        timeId: 'date',
        valueId: 'measurement',
        getValueY: function getValueY(v) {
          return v;
        },
        borderColor: 'darkorange',
        borderWidth: 2,
        fill: true,
        type: 'bar',
        show: this.person.weightColumnMeasurement,
        axesId: 'measurement'
      }, {
        title: t('health', 'Waist size', {}),
        columnId: 'waistSize',
        timeId: 'date',
        valueId: 'waistSize',
        getValueY: function getValueY(v) {
          return v;
        },
        borderColor: 'gray',
        borderWidth: 2,
        fill: false,
        show: this.person.weightColumnWaistSize,
        axesId: 'third'
      }, {
        title: t('health', 'Hip size', {}),
        columnId: 'hipSize',
        timeId: 'date',
        valueId: 'hipSize',
        getValueY: function getValueY(v) {
          return v;
        },
        borderColor: 'darkgray',
        borderWidth: 2,
        fill: false,
        show: this.person.weightColumnHipSize,
        axesId: 'third'
      }, {
        title: t('health', 'Muscle part', {}),
        columnId: 'musclePart',
        timeId: 'date',
        valueId: 'musclePart',
        getValueY: function getValueY(v) {
          return v;
        },
        borderColor: 'lightgreen',
        borderWidth: 2,
        fill: false,
        show: this.person.weightColumnMusclePart,
        axesId: 'musclePart'
      }];
    },
    options: function options() {
      return {
        title: {
          text: t('health', 'Chart')
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              minUnit: 'day'
            }
          }],
          yAxes: [{
            id: 'primary',
            gridLines: {
              display: true,
              color: 'gray',
              z: 100,
              lineWidth: 1
            },
            scaleLabel: {
              display: true,
              labelString: t('health', 'Weight')
            },
            min: 0,
            max: 100,
            position: 'left'
          }, {
            id: 'secondary',
            scaleLabel: {
              display: true,
              labelString: t('health', '')
            }
          }, {
            id: 'third',
            scaleLabel: {
              display: true,
              labelString: t('health', 'Sizes')
            } // min: 0,
            // max: 100,

          }, {
            id: 'bodyfat',
            scaleLabel: {
              display: true,
              labelString: t('health', 'bodyfat')
            }
          }, {
            id: 'bmi',
            scaleLabel: {
              display: true,
              labelString: t('health', 'Body mass index')
            }
          }, {
            id: 'measurement',
            scaleLabel: {
              display: true,
              labelString: this.person.weightMeasurementName
            }
          }, {
            id: 'musclePart',
            scaleLabel: {
              display: true,
              labelString: t('health', 'muscle part')
            }
          }]
        },
        tooltips: {
          enabled: true
        },
        layout: {
          padding: {
            right: 30,
            left: 25
          }
        },
        legend: {
          position: 'bottom'
        }
      };
    },
    chartStyle: function chartStyle() {
      return {
        height: '250px'
      };
    }
  }
};